module.exports = __webpack_public_path__ + "static/media/banner3.af4b50ce.jpg";